/**
 * Streifen bei übernommener Ansicht.
 *
 * Auffällig und dauerhaft sichtbar, und das ist der Punkt: die Übernahme hat
 * volle Rechte. Wer hier vergisst, in wessen Namen er arbeitet, schließt
 * womöglich eine Prüfung ab, und der Bericht trägt anschließend Namen und
 * Zertifikatsnummer des Übernommenen.
 *
 * Deshalb Rot statt der Hausfarben, deshalb der Name des Übernommenen im
 * Klartext, und deshalb steht der Weg zurück direkt daneben.
 */

import { useState } from 'react'
import { useKonto } from '../konto/KontoKontext'
import { Fehlerhinweis } from './Hinweise'

export function Uebernahmestreifen() {
  const { konto, uebernahmeBeenden } = useKonto()
  const [laeuft, setzeLaeuft] = useState(false)
  const [fehler, setzeFehler] = useState<unknown>(null)

  if (!konto?.handelt_als) return null

  return (
    <div
      role="status"
      className="border-b-2 border-stufe-3 bg-stufe-3-grund px-4 py-2 text-stufe-3"
    >
      <div className="mx-auto flex max-w-5xl flex-wrap items-center gap-x-3 gap-y-1">
        <span aria-hidden className="text-xl leading-none">
          ⚠
        </span>
        <span>
          Sie arbeiten als <span className="font-bold">{konto.name}</span>. Alles, was
          Sie hier tun, geschieht in dessen Namen.
        </span>
        <button
          type="button"
          className="knopf-warnung ml-auto bg-white px-3 py-1"
          style={{ minHeight: '40px' }}
          disabled={laeuft}
          onClick={() => {
            setzeLaeuft(true)
            setzeFehler(null)
            void uebernahmeBeenden()
              // Der Weg zurück ist der, auf den man sich verlassen muss.
              // Scheitert er stumm, sitzt man in der fremden Ansicht fest.
              .catch((f: unknown) => setzeFehler(f))
              .finally(() => setzeLaeuft(false))
          }}
        >
          {laeuft ? 'Wechselt …' : 'Zurück zur Verwaltung'}
        </button>
        {fehler != null && (
          <div className="w-full">
            <Fehlerhinweis fehler={fehler} />
          </div>
        )}
      </div>
    </div>
  )
}
